import styled, { css } from 'styled-components'

import { FlexGroup } from 'components/FlexGroup'
import { color, SubheadlineStyle, HeadingStyle } from 'styles/global'
import { MAX_WIDTH } from 'styles/theme'
import { space } from 'styles/utils'

export const Wrapper = styled.article``

export const SearchLoading = styled.div`
  align-items: center;
  color: ${color('secondaryText')};
  display: flex;
  justify-content: center;
  margin: ${space(14)} auto 0;
  max-width: 600px;
  padding: ${space(4)};
  padding: 20px 0;
  padding-top: ${space(2)};
  text-align: center;
  width: 100%;
`

export const AppFrame = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: ${MAX_WIDTH};
  min-height: var(--vh);
  width: 100%;
`

export const AppBody = styled.div`
  background: ${color('primaryBackground')};
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 auto;
  max-width: ${MAX_WIDTH};
  position: relative;
  width: 100%;

  @media only screen and (min-width: 650px) {
    background: none;
  }

  @media only screen and (min-width: 960px) {
    --navigation-height: 0px;
    background: none;
    padding-left: calc(var(--navigation-width) + ${space(5)});
  }
`
export const AppPage = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 0 calc(var(--navigation-height));

  &.noHorizontalPadding {
    padding-left: 0;
    padding-right: 0;
  }

  &.mobilePadding {
    padding-left: ${space(4)};
    padding-right: ${space(4)};
  }

  &.playerPadding {
    padding-bottom: calc(
      var(--navigation-height) + var(--player-height-offset)
    );
  }

  @media only screen and (min-width: 650px) {
    padding-left: ${space(4)};
    padding-right: ${space(4)};
  }

  &.constrain {
    @media only screen and (min-width: 960px) {
      margin: 0 auto;
      width: 100%;
      max-width: 900px;
    }
  }

  @media only screen and (min-width: 960px) {
    --navigation-height: 0px;
  }
`

export const AppHeaderVars = css`
  --header-height: 84px;

  @media only screen and (max-height: 650px) {
    --header-height: 44px;
  }
`

export const AppHeader = styled.div<{ secondary: boolean }>`
  align-items: center;
  background: ${color('secondaryBackground')};
  border-bottom: 1px solid ${color('primaryBorder')};
  color: ${color('primaryHeadingText')};
  display: flex;
  height: var(--header-height);
  padding: ${space(3)} ${space(6)};
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 50;

  .icon {
    margin-right: ${space(3)};
  }

  h1 {
    /* align-self: flex-end; */
    color: inherit;
  }

  @media only screen and (max-width: 650px) {
    h1 {
      ${HeadingStyle};
    }
  }

  @media only screen and (max-height: 650px) {
    padding: ${space(3)} ${space(4)};

    h1 {
      font-size: 1.1765rem;
    }
    .icon {
      width: 24px;
      height: 24px;
    }
  }

  ${({ secondary }) =>
    secondary &&
    css`
      align-items: center;
      h1 {
        ${SubheadlineStyle};
        color: inherit;
        margin-bottom: 0;
        margin-left: ${space(9)};
        margin-right: ${space(9)};
        text-align: center;
        text-transform: initial;
        width: 100%;
      }
      button {
        position: absolute;
      }
    `}
`

export const ModalContainer = styled.div<{ noScroll?: boolean }>`
  --modal-header-height: 84px;
  background: ${color('overlayBackground')};
  bottom: 0;
  color: white;
  height: 100%;
  left: 0;
  min-height: var(--vh);
  ${({ noScroll }) =>
    !noScroll &&
    css`
      overflow-y: scroll;
    `}
  position: fixed;
  right: 0;
  top: 0;
  width: 100vw;
  z-index: 200;

  @media only screen and (min-width: 650px) {
    padding-top: var(--header-height);
  }
`

export const ModalHeader = styled.header`
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 2;
  > div {
    align-items: center;
    display: flex;
    flex-direction: row;
    height: var(--modal-header-height);
    justify-content: flex-end;
    margin: 0 auto;
    max-width: ${MAX_WIDTH};
    padding: 0 ${space(4)};
    width: 100%;
  }

  @media only screen and (min-width: 650px) {
    background: ${color('secondaryBackground')};
  }
`

export const Logo = styled.figure<{ small?: boolean }>`
  align-items: center;
  a {
    display: inline-flex;
    justify-content: center;
  }
  img {
    max-height: 100%;
    max-width: 100%;
    width: auto;
    object-fit: contain;
  }
  &,
  a {
    height: 40px;
    width: 71px;
    transition: 0.2s all;
  }
  // large header on tall screens and on initial view.
  @media only screen and (min-height: 500px) {
    ${({ small }) =>
      !small &&
      css`
        &,
        a {
          height: 79px;
          width: 180px;
        }
      `}
  }
`
export const LoadingFailure = styled(FlexGroup).attrs({
  direction: 'column',
  gap: 2,
  forwardedAs: 'section',
})`
  color: ${color('primaryText')};
  text-align: center;
  width: 100%;
`

export const CloseButton = styled.button`
  color: ${color('primaryText')};
  padding: ${space(3)} ${space(4)};
`
